import {useMemo} from 'react';
import styled from 'styled-components';
import {AnalysisItem, BasicAnalysisResult} from '@/map/@types';
import {useOfficeWorkerPointBy} from '@/map/api';
import {getSidoName} from '@/map/utils';
import {Flexbox, FlexFullGrow, PaddingBox} from '@/styled-components';
import {palette} from '@/styles';
import {withComma} from '@/utils';
import {BarChart} from '../BarChart';
import {SectionLabel, SectionValue} from '../StyledComponents';
import {CompareAverage} from './CompareAvg';

interface IProps {
  item: AnalysisItem;
  data?: BasicAnalysisResult;
}

const AGE_GROUP = ['20대', '30대', '40대', '50대', '60대', '60대 초과'];

export const OfficeWorker = ({data, item}: IProps) => {
  if (!data || !data?.officeWorker) {
    return (
      <Root>
        <Flexbox>
          <SectionLabel>직장 인구</SectionLabel>
          <FlexFullGrow />
          <SectionValue color={palette.gray300}>정보 없음</SectionValue>
        </Flexbox>
      </Root>
    );
  }

  const ctprvn = getSidoName(data?.average?.sido);
  const avg = data?.average?.officeWorker;

  return (
    <Root>
      <Flexbox>
        <SectionLabel>직장 인구</SectionLabel>
        <FlexFullGrow />
        <SectionValue>
          {withComma(Math.round(data.officeWorker))} 명
        </SectionValue>
      </Flexbox>
      {!!avg && (
        <PaddingBox top={8}>
          <CompareAverage
            total={data?.officeWorker}
            average={avg}
            ctprvn={ctprvn}
          />
        </PaddingBox>
      )}
      <ChartData item={item} />
    </Root>
  );
};

const ChartData = ({item}: {item: AnalysisItem}) => {
  const {data: rawdata, isPending, error} = useOfficeWorkerPointBy(item);

  const data = useMemo(() => {
    if (!rawdata?.officeWorker) {
      return;
    }

    const gap = rawdata.officeWorker.male.length - AGE_GROUP.length;

    return AGE_GROUP.map((_, idx) => {
      const male = Math.round(rawdata.officeWorker?.male?.[idx + gap] || 0);
      const female = Math.round(rawdata.officeWorker?.female?.[idx + gap] || 0);

      return {
        male,
        female,
        sum: male + female,
      };
    });
  }, [rawdata]);

  if (isPending || !!error || !data) {
    return null;
  }

  return <BarChart labels={AGE_GROUP} data={data} />;
};

const Root = styled.div``;
